import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-roboto';
import './index.css';
import { App } from './App';
import { Provider } from 'react-redux';
import store from './store';
import { CartContextProvider } from './context/Cart';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <CartContextProvider>
        <App />
      </CartContextProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
